import type { DashboardSummaryDTO } from "@/modules/dashboard/domain/types";
import { config } from "@/shared/lib/config";
import { fetcher } from "@/shared/lib/fetcher";

export const dashboardApi = {
  async summary(): Promise<DashboardSummaryDTO> {
    return fetcher.get(`${config.apiUrl}/dashboard/summary`);
  },
};
